<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="9" viewBox="0 0 16 9">
        <g fill="none" fill-rule="evenodd" stroke="#4A9BF9" stroke-linecap="round">
            <path d="M.533 3.733L15.467 3.733M11.2.533L15.467 3.733M15.467 3.733L11.2 6.933" transform="rotate(-180 8 4.233)"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'prev-icon'
}
</script>